/*
 * @Author: your name
 * @Date: 2022-03-01 13:56:28
 * @LastEditTime: 2022-09-25 21:57:05
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\clients\store.ts
 */
import lodash from 'lodash';
import { EnumAPI } from './apis';
import * as Controller from './controller';
import Env from './env';
import { AjaxBasics, Log } from './libraries';
export function createStore() {
  const Store = {
    /** 系统 登陆注册 */
    System: new Controller.SystemController(),
    /** 用户信息 */
    UserInfo: new Controller.UserInfoController(),
    Currency: new Controller.CurrencyController(),
    /** 微信 */
    Wechat: new Controller.WechatController(Env.appid),
    /** 分享 */
    Share: new Controller.ShareController(),
    /** lenovoid */
    Lenovoid: new Controller.LenovoidController(),
    /** 中间页 */
    MiddlePage: new Controller.MiddlePageController(),
    /** adfs */
    Adfs: new Controller.AdfsController(),
    /** 小智相关 */
    Xiaozhi: new Controller.XiaozhiController(),
    /** 小智相关 */
    Protocol: new Controller.ProtocolController(),
    /** 客户端相关 */
    Client: new Controller.ClientController(),
  };
  AjaxBasics.merge = async (AjaxConfig) => {
    function setHeaders() {
      // // 配置 token
      // if (Store.System.AccessToken) {
      //   // const isToken = lodash.some(['bpportal-mall'], item => lodash.includes(AjaxConfig.url, item))
      //   const tokenKey = 'bp-token';
      //   lodash.merge(AjaxConfig, {
      //     headers: { [tokenKey]: Store.System.AccessToken },
      //   });
      // }
      // 配置 token
      if (Store.System.AccessToken) {
        const tokenKey = 'bp-token';
        lodash.merge(AjaxConfig, {
          headers: { [tokenKey]: Store.System.AccessToken },
        });
      }
      const systemSource = lodash.get(AjaxConfig, 'body.systemSource');
      if (systemSource && lodash.includes([3, 31], systemSource)) {
        const promoCodeTarget = lodash.get(
          {
            release: {
              accountsvr_user_add: 'c2efe7bee85e4ea6a7b2556851c20742',
              orgidass_smb_register: '21a254dc6a7a429c83f3e6ba7940f370',
              orgidass_rel_register: '12a86a07f308497f8dba17197c4032fe',
            },
          },
          Env.APP_ENV,
          {
            accountsvr_user_add: '4e8fc6e8ba0e4d20bb0a67a6a3658a5d',
            orgidass_smb_register: 'd83af8133bdc4ded9350870ca464b273',
            orgidass_rel_register: '1c150c32549c4a58a5bdc032fcf1b744',
          },
        );
        let promoCode = '';
        if (EnumAPI.accountsvr_user_add.url == AjaxConfig.url) {
          promoCode = promoCodeTarget.accountsvr_user_add;
        }
        if (EnumAPI.orgidass_smb_register.url == AjaxConfig.url) {
          promoCode = promoCodeTarget.orgidass_smb_register;
        }
        if (EnumAPI.orgidass_rel_register.url == AjaxConfig.url) {
          promoCode = promoCodeTarget.orgidass_rel_register;
        }
        lodash.merge(AjaxConfig, {
          headers: {
            'x-bp-promo-code': promoCode,
            'x-source-website': 'LCIC',
          },
        });
      }
      // 分享码
      if (Store.Share.promoSource) {
        lodash.merge(AjaxConfig, {
          headers: { 'x-source-website': Store.Share.promoSource },
        });
      }

      // 分享码
      if (Store.Share.shareCode) {
        lodash.merge(AjaxConfig, {
          headers: { 'x-bp-promo-code': Store.Share.getHeaderValue() },
        });
      }
      // BU
      if (!lodash.includes(AjaxConfig.url, '/idaas/public/v1/users/add')) {
        if (Store.System.User.BU) {
          lodash.merge(AjaxConfig, {
            headers: { 'x-business-unit': Store.System.User.BU },
          });
        }
      }
      // uid
      if (Store.Client.uid) {
        lodash.merge(AjaxConfig, {
          headers: { 'x-bp-client-id': Store.Client.uid },
        });
      }
    }
    setHeaders();
    // 默认 所有请求都需要等待用户完成 带有标记 和 已完成 则跳过
    if (
      lodash.eq(AjaxConfig.awaitAuthenticated, false) ||
      Store.System.Auth.HydrateisStopped
    ) {
      return AjaxConfig;
    }
    Log.warning(`等待用户初始化完成 【 ${AjaxConfig.url} 】`, AjaxConfig);
    await Store.System.Auth.HydrateAsync;
    setHeaders();
    return AjaxConfig;
  };
  return Store;
}
